// extracted by mini-css-extract-plugin
module.exports = {"patientName":"Table_patientName__3qRUu","productName":"Table_productName__1oS37"};